import { createContext, use } from "react";
import type { ApiResponse } from "@entrilia/shared/api/types.ts";
import { defined } from "@entrilia/shared/utilities/typeHelper.ts";
import type {
  GetReportAuthorizationResponse,
  NameValidationResponse,
  ReportAuthorizationInfo,
  UpdateReportAuthorizationRequest,
  ValidateReportNameRequest,
} from "../../../../../api/types/svTypes.ts";

export interface BiApiClientBase {
  validateName: (request: ValidateReportNameRequest) => Promise<ApiResponse<NameValidationResponse>>;
  getReportSharing: (reportId: string) => Promise<ApiResponse<GetReportAuthorizationResponse>>;
  updateReportSharing: (
    reportId: string,
    request: UpdateReportAuthorizationRequest
  ) => Promise<ApiResponse<ReportAuthorizationInfo>>;
  getEditReportUrl: (clientCode: string, reportId: string) => string;
  getViewReportUrl: (clientCode: string, reportId: string) => string;
}

export const BiApiClientContext = createContext<BiApiClientBase | undefined>(undefined);

export const useBiApiClientProvider = <T extends BiApiClientBase = BiApiClientBase>(): T => {
  const client = use(BiApiClientContext) as T | undefined;
  return defined(client);
};
